import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import SVG from "../../components/SVG";
import {
  Container,
  Row,
  Col,
  Button,
  Nav,
  NavItem,
  NavLink as NavTab,
  Input,
  LoadingIndicator
} from "../../components/simple";
import ErrorBoundary from "../../components/simple/ErrorBoundary";
import Header from "../../components/complex/Header";
import Variable from "../../components/complex/Variable";
import { ModalAudienceForm } from "../../components/forms/CreateAudienceDescription";
import PresetPopper from "./PresetPopover";
import * as routes from "../../router/routes";
import countryList from "../../assets/countries.json";
import "../../styles/pages/audiencesCreate.scss";
import Api from "../../api";

import { permissions, AccessControl } from "../../components/permissions";
import { clearPresets } from "../../store/entities/audience/audience.actions";

const presetStatusList = [
  "All",
  "Most used",
  "Last used",
  "3rd used",
  "4th used"
];

function getVariablesFromPreset(preset) {
  return preset.groups.map(group => group.variables);
}

class AudienceCreateFromTemplate extends Component {
  constructor(props) {
    super(props);
    const {
      location: { state }
    } = props;
    const isCountrySelected = !!state?.country;
    this.state = {
      searchString: "",
      presetPopoverId: "",
      presetChoosed: "",
      country: "",
      presetStatus: presetStatusList[0],
      showSearch: false,
      withFileUpload: isCountrySelected,
      isDescriptionModalOpen: !isCountrySelected,
      customerAnalysisError: false,
      data: {},
      ...state
    };
    this.handlePresetPopover = this.handlePresetPopover.bind(this);
    this.handleChoosePreset = this.handleChoosePreset.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNavLinkSearch = this.handleNavLinkSearch.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
    this.handleSearchClick = this.handleSearchClick.bind(this);
    this.handlePresetStatus = this.handlePresetStatus.bind(this);
    this.handleDescriptionModal = this.handleDescriptionModal.bind(this);
    this.navigateToBuilder = this.navigateToBuilder.bind(this);

    this.container = React.createRef();
  }

  componentDidMount() {
    this.props.clearPresetsInState();

    const init = async () => {
      const { country } = this.state;
      const { presets } = this.props;
      await Api.client.get();
      await Api.audience.countries({
        params: {
          country,
          has_data: true
        }
      });
      if (country) {
        await Api.audience.presets({
          params: {
            country
          },
          isNewBackendSearchOrFiltering: true
        });

        if (presets.length) {
          this.setState({
            presetStatus:
              this.props.presets && this.props.presets.length
                ? presetStatusList[0]
                : ""
          });
        }
      }
    };
    this.setState({ presetPopoverId: "" }, () => {
      init();
    });
  }

  handleCreateAudienceCustomerAnalysisWithoutData = async (data, file) => {
    const { history } = this.props;

    const response = await Api.audience.variables({
      params: {
        search: data.name
      }
    });

    if (response.payload.length) {
      this.setState({
        customerAnalysisError: true
      });

      return;
    }
    this.setState({
      customerAnalysisError: false
    });

    const newAudience = await Api.audience.add({
      data: {
        name: data.name,
        client: data.clientsId ? data.clientsId : null,
        country: data.country ? data.country : this.props.countries[0].name,
        audienceType: "Custom",
        method: "ll"
      }
    });

    file.set("audience_id", newAudience.id);

    await Api.audience.attachFile({
      params: {
        audience_id: newAudience.id
      },
      data: file
    });

    history.push(
      `${routes.fullReport}/${newAudience.id}/${newAudience.threshold}/audience`
    );
  };

  async handleDescriptionChange(data, file) {
    const { isDescriptionModalOpen, withFileUpload } = this.state;
    const { history } = this.props;

    if (withFileUpload) {
      const response = await Api.audience.variables({
        params: {
          search: data.name
        }
      });
      if (response.payload.length) {
        this.setState({
          customerAnalysisError: true
        });

        return;
      }
      this.setState({
        customerAnalysisError: false
      });
    }

    if (!withFileUpload) {
      await Api.audience.add({
        data: {
          // clientsId: data.clientsId ? [data.clientsId] : [],
          country: data.country,
          audienceType: "Custom",
          method: "ll"
        }
      });
      this.setState({ presetPopoverId: "" });
      await Api.audience.presets({
        params: {
          country: data.country
        }
      });
      // this.setState({ presetPopoverId: '' }, () => {
      // fetchPresets();
      // });
      if (this.props.presets) {
        this.setState({
          data: this.props.created,
          presetStatus:
            this.props.presets && this.props.presets.length
              ? this.props.presets[0].status
              : "",
          withFileUpload: !withFileUpload,
          isDescriptionModalOpen: !isDescriptionModalOpen
        });
      }
    }
    if (file) {
      file.set("audience_id", data.id);
      await Api.audience.edit({
        id: data.id,
        data: {
          // ...data,
          name: data.name,
          country: data.country,
          client: data.clientsId ? data.clientsId : null,
          audienceType: "Pre-build"
          // method: "ll",
        }
      });
      await Api.audience.attachFile({
        params: {
          audience_id: data.id
        },
        data: file
      });
      this.setState({
        data: {
          country: {
            name: data.country
          }
        },
        isDescriptionModalOpen: !isDescriptionModalOpen
      });
      history.push(
        `${routes.fullReport}/${data.id}/${data.threshold}/audience`
      );
    }
  }

  handlePresetPopover(newState) {
    this.setState({ presetPopoverId: newState });
  }

  handleChoosePreset(newState) {
    this.setState(({ presetChoosed }) => ({
      presetChoosed: newState === presetChoosed ? "" : newState
    }));
  }

  handleInputChange(name, value) {
    this.setState({ [name]: value });
  }

  handleNavLinkSearch() {
    const { showSearch } = this.state;
    if (!showSearch) {
      this.setState({ showSearch: true });
    } else {
      this.setState({ showSearch: false });
    }
  }

  handleSearch(showSearch) {
    const { presetStatus: currentStatus } = this.state;

    const presetStatus = showSearch ? presetStatusList[0] : currentStatus;

    this.setState({ showSearch, presetStatus });
  }

  handlePresetStatus(presetStatus) {
    this.setState({ presetStatus, presetPopoverId: "" });
  }

  handleDescriptionModal(isDescriptionModalOpen) {
    this.setState({ isDescriptionModalOpen });
  }

  handleSearchBlur() {
    this.setState({ showSearch: false });
  }

  // eslint-disable-next-line class-methods-use-this
  handleSearchClick(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  async navigateToBuilder() {
    const { history, presets } = this.props;
    const { country, data, presetChoosed } = this.state;
    const selectedPreset = presets.find(preset => preset.id === presetChoosed);
    const variables = selectedPreset.groups.map(
      ({ variables: listOfPresetVariables }) =>
        listOfPresetVariables.map(variable => variable.id)
    );

    await Api.audience.edit({
      id: data.id,
      data: {
        // ...data,
        // country: country || data.country.name,
        variables,
        // client: data.clientsId ? data.clientsId : null,
        audienceType: "Pre-build",
        threshold: selectedPreset.threshold
      }
    });

    history.push(routes.audiencesCreateWithoutTemplate(data.id), {
      audience: {
        ...data,
        variables,
        audienceType: "Pre-build",
        threshold: selectedPreset.threshold
      },
      preset: presets.find(preset => preset.id === presetChoosed),
      selectedVariables: getVariablesFromPreset(
        presets.find(preset => preset.id === presetChoosed)
      ),
      country: country || data.country.name
    });
  }

  render() {
    document.title = "Audience Preset | Global Data Resources";
    const {
      searchString,
      presetPopoverId,
      presetChoosed,
      showSearch,
      isDescriptionModalOpen,
      withFileUpload,
      data,
      country,
      presetStatus,
      customerAnalysisError
    } = this.state;
    const {
      history,
      presets,
      clients,
      countries = [],
      isLoadingPresets,
      location: {
        state: { withEmptyData = false }
      }
    } = this.props;

    const singleCountryData = this.props.location.state.singleCountry
      ? { country: { name: this.props.location.state.singleCountry } }
      : {};

    const filteredPresets = presets
      .filter(preset =>
        searchString
          ? preset.name.toLowerCase().includes(searchString.toLowerCase())
          : !searchString
      )
      .filter(preset =>
        presetStatus === "All" ? true : preset.status === presetStatus
      );
    const countryCode =
      country &&
      countryList
        .find(countryItem => countryItem.label === country)
        .code.toLowerCase();

    return (
      <Container id="audiences-create" fluid>
        <div className="audiences-background">
          <div className="background-light" />
        </div>
        <Container
          className="audiences-container"
          style={{ height: "100vh" }}
          ref={this.container}
        >
          <Row>
            <Header />
          </Row>
          <Row className="audiences-dashboard">
            <h2 className="title">Pick your starting point</h2>
          </Row>
          <Row className="description-row">
            <Col xl={8} className="p-0">
              <p className="description"></p>
              <br />
              <p className="description">
                For:{" "}
                <span className={`flag-icon flag-icon-${countryCode}`}></span>
              </p>
            </Col>
            <Col xl={4} className="p-0 link-col">
              <NavLink
                className="create-link"
                to={{
                  pathname: routes.audiencesCreateWithoutTemplate(data.id),
                  state: {
                    country,
                    audience: {
                      ...data
                    },
                    from: "createFromTemplate"
                  }
                }}
              >
                <SVG.Plus />
                Create without template
              </NavLink>
            </Col>
          </Row>
          <Row className="nav-row">
            <Nav tabs className={showSearch ? "active-search" : ""}>
              {presetStatusList.map(name => (
                <NavItem key={name}>
                  <NavTab
                    onClick={() => this.handlePresetStatus(name)}
                    active={presetStatus === name}
                  >
                    {name}
                  </NavTab>
                </NavItem>
              ))}
              <NavItem
                className="search-item"
                onClick={this.handleNavLinkSearch}
              >
                <NavTab
                  active={showSearch}
                  onClick={() => this.handleSearch(!showSearch)}
                >
                  <div className="search-container">
                    {showSearch ? (
                      <Input
                        label=""
                        containerClass="search"
                        placeholder="Search"
                        handleChange={this.handleInputChange}
                        name="searchString"
                        value={searchString}
                        onClick={this.handleSearchClick}
                        onBlur={this.handleSearchBlur}
                        setFocus
                      />
                    ) : null}
                    <SVG.HeaderSearch className="nav-icon" />
                    <span className={showSearch ? "hide" : ""}>Search</span>
                  </div>
                </NavTab>
              </NavItem>
            </Nav>
          </Row>
          <Row className="variables-row">
            {// eslint-disable-next-line no-nested-ternary
            isLoadingPresets ? (
              <div className="w-100 d-flex justify-content-center">
                <LoadingIndicator />
              </div>
            ) : filteredPresets.length ? (
              filteredPresets.map(preset => (
                <Fragment key={preset.id}>
                  <Variable
                    active={preset.id === presetChoosed}
                    label={preset.name}
                    onClick={() => this.handleChoosePreset(preset.id)}
                    onFocus={() => this.handlePresetPopover(preset.id)}
                    onMouseOver={() => this.handlePresetPopover(preset.id)}
                    id={`preset-popper-${preset.id}`}
                  />
                  <ErrorBoundary>
                    <PresetPopper
                      id={presetPopoverId}
                      toggle={this.handlePresetPopover}
                      preset={preset}
                      boundariesElement={this.container.current}
                    />
                  </ErrorBoundary>
                  <div style={{ display: "none" }}>{presetPopoverId}</div>
                </Fragment>
              ))
            ) : (
              <h3 className="title">No presets to choose</h3>
            )}
          </Row>
          <Row className="pb-4">
            <Button
              disabled={!presetChoosed}
              onClick={this.navigateToBuilder}
              className="button"
            >
              NEXT
            </Button>
            <AccessControl allow={permissions.customerAnalysis.view}>
              <Button
                disabled={!!presetChoosed}
                onClick={() =>
                  this.handleDescriptionModal(!isDescriptionModalOpen)
                }
                className="button button-transparent"
              >
                Customer analysis
              </Button>
            </AccessControl>
          </Row>
        </Container>
        <ModalAudienceForm
          customerAnalysisError={customerAnalysisError}
          // data={data}
          data={Object.keys(data).length ? data : singleCountryData}
          type={
            history?.location?.state?.type ? history?.location?.state?.type : ""
          }
          clients={clients}
          countries={countries}
          isOpen={isDescriptionModalOpen}
          withFileUpload={withFileUpload}
          changeModalState={() => {
            if (isDescriptionModalOpen) {
              history.push(routes.audiences(""));
            }
            return withFileUpload
              ? this.handleDescriptionModal(!isDescriptionModalOpen)
              : null;
          }}
          handleSubmit={
            withEmptyData
              ? this.handleCreateAudienceCustomerAnalysisWithoutData
              : this.handleDescriptionChange
          }
        />
      </Container>
    );
  }
}

const mapStateToProps = ({ audiences, clients }) => {
  return {
    countries: audiences.countries,
    created: audiences.added,
    presets: audiences.presets,
    isLoadingPresets: audiences.isLoadingPresets,
    clients: clients.data
  };
};

const mapDispatchToProps = {
  clearPresetsInState: clearPresets
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AudienceCreateFromTemplate));

AudienceCreateFromTemplate.propTypes = {
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string
    })
  ).isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string
    })
  ).isRequired,
  clients: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  created: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      state: PropTypes.shape({
        type: PropTypes.string
      })
    })
  }).isRequired,
  location: PropTypes.shape({
    state: PropTypes.shape({
      country: PropTypes.string,
      withEmptyData: PropTypes.bool,
      singleCountry: PropTypes.string
    })
  }).isRequired,
  isLoadingPresets: PropTypes.bool.isRequired,
  clearPresetsInState: PropTypes.func.isRequired
};
